/**
 * @author: Raghav Prabhu
 */
export const apiVersion = 'v1.0';

export const appVersion = process.env.REACT_APP_DF_VERSION;

export const validEmailRegex = RegExp(/^(([^<>()\[\]\.,;:\s@\"]+(\.[^<>()\[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i);
export const validURL_REGEXP = RegExp('(https?://)?([\\da-z.-]+)\\.([a-z.]{2,6})[/\\w .-]*/?');
export const PASSWORD_REGEXP = RegExp(/(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[$@$!%*?&])[A-Za-z\d$@$!%*?&].{8,30}/);
export const ACCESS_TOKEN = 'accessToken';
export const SIGNIN_AUTH_TOKEN = 'AuthToken';

export const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
export const SOCKET_API_BASE_URL = process.env.REACT_APP_API_SOCKET_URL;
export const OAUTH2_REDIRECT_URI = 'https://platform.decisionforce.io/admin/oauth2/redirect'
export const GOOGLE_AUTH_URL = API_BASE_URL + '/oauth2/authorize/google?redirect_uri=';
export const MICROSOFT_AUTH_URL = API_BASE_URL + '/oauth2/authorize/azure?redirect_uri=';
// Cloud Storage
export const STORAGE_BASE_URL = process.env.REACT_APP_STORAGE_BASE_URL;
export const DRS_BASE_URL = process.env.REACT_APP_DRS_BASE_URL;

export const NOTEBOOK_WS_CONNECTOR_URL = process.env.REACT_APP_NOTEBOOK_WS_CONNECTOR_URL;

//Connector Storage
export const CONNECTOR_BASE_URL = process.env.REACT_APP_CONNECTOR_BASE_URL;

export const NOTEBOOK_WS_CONNETING_TIMER = 120000;
export const NOTEBOOK_WS_NOT_RECEIVE = 30000;
export const wsContinuousHitWaitTime = 10000; // 10 seconds
export const EXPIRE_SIGNIN_AUTH_TOKEN = 60000;

export const WEBSOCKET_RECONNECT_MILLISECONDS = 30000;

export const WEBSOCKET_NO_OF_TRY = 5;

export const modelSpaceMount = "MODELSPACE";

export const defaultStroageName = "DFDrive";

export const CAPTCHA_API_KEY = "6Lf8LNofAAAAAF44H8_KuUOSgjj66osbQ3b22w0k";

export const STORAGE_EXTERNAL_MOUNT_PATH = "/mnt/";

export const STORAGE_DEFAULT_MOUNT_PATH = "/content/";

export const AccountLogoSize = 1;  // in MB

export const LogoWidth = 250;

export const LogoHeight = 250;

export const LogoErrorMessageMin = "Logo size should be less than 1 MB";

export const LogoErrorMessageDimension = "Logo dimensions(Height x Width) : 250 x 150 ";

//RUN Status Messages
export const RUN_PROGRESS_STATUS = "Progress";
export const RUN_EXECUTING_STATUS = "Executing";
export const RUN_COMPLETED_STATUS = "Completed";
export const RUN_FAILED_STATUS = "Failed";
export const RUN_CANCELLED_STATUS = "Cancelled";

export const VERSIONTIMEOUT = 5000;

export const INTERVALSEARCH = 1000;

export const NO_OF_RECORDS = 1000;

export const newNotebookSample = {

  "cells": [{

    "cell_type": "code",
    "execution_count": null,
    "metadata": {
      "tags": []
    },
    "source": "",
    "outputs": [],
  }]

};


export const tenantExclude = ["Accounts", "Platform", "Compute"];  // for tenant Admin, developer, tenant management
export const platformAdminInclude = ["Accounts", "Storage", "Platform", "Compute", "Cluster", "Provisioners", "Machine Type", "Cloud Images"];
export const generalUserInclude =  ["Projects", "Runs", "Chat", "Storage"];

export const csv = "far fa-file-excel mr-2";

export const ipynb = "fas fa-book-open mr-2";

export const image = "fas fa-file-image mr-2";

export const defaultIcon = "far fa-file mr-2";

export const jwtToken = localStorage.getItem('accessToken')

//export const tenanttoken = "false";

export const default_StorageName = "PlatformDefault";
export const default_LabelStorageName = "DFDrive";

export const vmServiceName = "VIRTUAL_MACHINE";

export const MenuNames = {
  PowerBI : "PowerBI"
}

export const provisioners = {
  google: 'GOOGLE',
  aws: 'AWS',
  azure: 'AZURE'
}

export const userRoles = {
  PLATFORM_ADMIN: 'PLATFORM_ADMIN',
  TENANT_ADMIN : "TENANT_ADMIN",
  TENANT_MANAGEMENT : "TENANT_MANAGEMENT",
  GENERAL_USER : "GENERAL_USER",
  DEVELOPER : "DEVELOPER"
}

export const HandsonTableKey = 'a8671-103d5-94be3-94525-c2017';

export const provisionerService = {
  kubernetesCluster: 'KUBERNETES_CLUSTER',
  virtualMachine: 'VIRTUAL_MACHINE',
  storage: 'STORAGE'
}

export const provisionerServiceList = [
  { label: 'Storage', value: provisionerService.storage, badge: "badgeTagStorage" },
  { label: 'Kubernetes Cluster', value: provisionerService.kubernetesCluster, badge: "badgeTagCluster" },
  { label: 'Virtual Machine', value: provisionerService.virtualMachine, badge: "badgeTagVM" }
];

export const CLUSTERSTATUS = {
  PENDING: "PENDING",
  STARTING: "STARTING",
  CREATING: "CREATING",
  RUNNING: "RUNNING",
  STOPPING: "STOPPING",
  PROVISIONING: "PROVISIONING",
  DELETING: "DELETING",
  RESTARTING: "RESTARTING",
  STOPPED: "STOPPED",
  DELETED: "DELETED",
  NOT_FOUND: "NOT_FOUND",
  UNKNOWN: "UNKNOWN",
  FAILED: "FAILED",
  ERROR: "ERROR"
};


export const STORAGE_JOB_VARIABLES = {
  MOVE : "MOVE",
  COPY : "COPY",
  RENAME : "RENAME",
  MOVE_TO_TRASH : "MOVE_TO_TRASH",
  RESTORE : "RESTORE",
  FILE_EXTRACTION : "FILE_EXTRACTION",
  VERSION : "VERSION",
}

export const MODULETYPES = {
  STORAGE: 'STORAGE',
  NOTIFICATION : "NOTIFICATION",
  REFRESH : "REFRESH",
  RUN : "RUN",
  CHAT : "CHAT",
  CONSUMED_HOURS : "CONSUMED_HOURS",
  CLUSTER : "CLUSTER"
}

export const APIRESPONSE ={
  SUCCESS : "SUCCESS",
  FAILURE : "FAILURE"
}

export const THEME = [
  { label: 'Light', value: "light" },
  { label: 'Primary', value: "primary" },
  { label: 'Info', value: "info" },
  { label: 'Success', value: "success" },
  { label: 'Warning', value: "warning" },
  { label: 'Danger', value: "danger" },
];

export const dataSoruce = [
  { label: 'JSON', value: "JSON" },
  { label: 'URL', value: "URL" }
];

export default {
  api: {
    base: { url: API_BASE_URL },
    auth: {
      login: 'login/' + apiVersion + '/',
      authLogin: 'login/' + apiVersion + '/auth/signin',
      validateAuth: 'login/' + apiVersion + '/auth/validate',
      authAccounts: 'login/' + apiVersion + '/auth/accounts',
      register: 'login/' + apiVersion + '/register/user',
      forgotPass: 'forgotpassword/',
      forgotPassResetlink: 'forgotpassword/reset/password',
      signupVerify: 'auth/signup/verify'

    },
    user: {
      userProfile: 'api/' + apiVersion + '/user/me',
      chatUses: 'api/' + apiVersion + '/user/list',
      getAllusers: 'api/' + apiVersion + '/tenant/list',
      postNewUser: 'api/' + apiVersion + '/tenant/register/user',
      getRole: 'api/' + apiVersion + '/user',
      updateUser: 'api/' + apiVersion + '/user',
      deleteUser: 'api/' + apiVersion + '/tenant',
      activateUser: 'api/' + apiVersion + '/tenant/activate',
      deactivateUser: 'api/' + apiVersion + '/tenant/deactivate',
      updatePassword: 'api/' + apiVersion + '/user/updatepassword'

    },
    run: {
      newRun: 'api/' + apiVersion + '/run/new',
      getAllrun: 'api/' + apiVersion + '/run/me',
      GetRunbySize: 'api/' + apiVersion + '/run/masterjob',
      GetLatestRun: 'api/' + apiVersion + '/' + 'run/latest',
      getRunById: 'api/' + apiVersion + '/run/by/',
      postNewrun: 'api/' + apiVersion + '/run/submit',
      postrerun: 'api/' + apiVersion + '/run/run/project',
      cancelJob: 'api/' + apiVersion + '/run/cancel',
      removeJob: 'api/' + apiVersion + '/run/remove',
      downloadFile: 'api/' + apiVersion + '/run/download',
      getPostChat: 'api/' + apiVersion + '/chat/',
      getRerun: 'api/' + apiVersion + '/run/again',
      getJobrun: 'api/' + apiVersion + '/run/job/',
      getchatCount: 'api/' + apiVersion + '/chat/all',
      getMessages: 'api/' + apiVersion + '/chat/by/job/',
      getMessagesScroll: 'api/' + apiVersion + '/chat/job/',
      updateReadStatus: 'api/' + apiVersion + '/chat/notification/update',
      getRunTimeImageList: 'api/' + apiVersion + '/run/agent/container/images',
      getTableParaset: 'api/' + apiVersion + '/run/parameter-tables',
      createTag: 'api/' + apiVersion + '/run/run/tags/',
      getTagsRun: 'api/' + apiVersion + '/run/autocomplete/tags',
      getAutocompleteRun: 'api/' + apiVersion + '/run/autocomplete/tags/result',
      getComputeHours: 'api/' + apiVersion + '/run/get/compute-minutes',
      getRunSearch: 'api/' + apiVersion + '/run/run-search'

    },
    chat: {
      joblist: 'api/' + apiVersion + '/chat/by/run/list',
      projectlist: 'api/' + apiVersion + '/chat/by/project/list',
      Getmessagelist: 'api/' + apiVersion + '/chat/by/run/message/',
      Getchatmessage: 'api/' + apiVersion + '/chat/by/message/identifier/',
      PostMediamessage: 'api/' + apiVersion + '/chat/media',
    },
    project: {
      analyze: 'api/' + apiVersion + '/analyze',
      newProject: 'api/' + apiVersion + '/project',
      getallProject: 'api/' + apiVersion + '/project/all',
      getProjectbyId: 'api/' + apiVersion + '/project',
      run: 'api/' + apiVersion + '/run/run/project',
      update: 'api/' + apiVersion + '/project',
      delete: 'api/' + apiVersion + '/project',
      getrunsbyId: 'api/' + apiVersion + '/run/run/project',
      compareTable: 'api/' + apiVersion + '/analyze/compare/data',
      getRecentProject: 'api/' + apiVersion + '/project/recent',
      getTagsProject: 'api/' + apiVersion + '/project/autocomplete',
      addFavProject: 'api/' + apiVersion + '/project/favorites',
      getFavProject: 'api/' + apiVersion + '/project/favorites',
      getAutocomplete: 'api/' + apiVersion + '/project/autocomplete/result',
      compareDownload: 'api/' + apiVersion + '/analyze/download',
    },
    storage: {
      viewFile: 'api/' + apiVersion + '/storage/file/download',
      csvPaginate: 'api/' + apiVersion + '/csv/data'
    },
    cluster: {
      getAllEngine: 'api/' + apiVersion + '/cluster/engine',
      newEngine: 'api/' + apiVersion + '/cluster/engine',
      newCluster: 'api/' + apiVersion + '/cluster/k8s',
      getAllCluster: 'api/' + apiVersion + '/cluster/k8s',
      getClusterByid: 'api/' + apiVersion + '/cluster/k8s/',
      deleteClusterByid: 'api/' + apiVersion + '/cluster/k8s/',
      getmachinetypes: 'api/' + apiVersion + '/cluster/machinetypes/',
      cloneK8s: 'api/' + apiVersion + '/cluster/k8s/clone/',
      startK8s: 'api/' + apiVersion + '/cluster/k8s/start/',
      stopK8s: 'api/' + apiVersion + '/cluster/k8s/stop/',
      restartK8s: 'api/' + apiVersion + '/cluster/k8s/restart/',
      liveStatusK8s: 'api/' + apiVersion + '/cluster/k8s/status/',
      forceDelete: 'api/' + apiVersion + '/cluster/k8s/force/'
    },
    cloud: {
      getCloudImageName: 'api/' + apiVersion + '/cloud/machine/images/list/by/cloud/',
      getInstanceTypeAlias: 'api/' + apiVersion + '/cloud/instancetype/alias/list/by/cloud/',
      getInstanceTypeHint: 'api/' + apiVersion + '/cloud/instancetype/alias/list/instance/type/by/region/',
      getAliasNameByProvisioner: 'api/' + apiVersion + '/cloud/instancetype/alias/list/by/provisioner/',
      getAllVirtualMachineType: 'api/' + apiVersion + '/cloud/virtualmachine/type/list/',
      getAllCloudImages: 'api/' + apiVersion + '/cloud/machine/images/list/'
    },
    connector: {
      postConnector: 'api/' + apiVersion + '/connectors',
      getConnectorsByType: 'api/' + apiVersion + '/connector/getByConnectorType',
      getConnectorsById: 'api/' + apiVersion + '/connectors/',
      removeConnector: 'api/' + apiVersion + '/connectors/',
      getAllConnector: 'api/' + apiVersion + '/connectors/all',
      getAllConnectors: 'api/' + apiVersion + '/connectors/list',
      updateConnector: 'api/' + apiVersion + '/connectors/',
      getConnectorsByName: 'api/' + apiVersion + '/connectorbase/group',
      getConnectorsbaseById: 'api/' + apiVersion + '/connectorbase/',
      getGroupName: 'api/' + apiVersion + '/connector/base/group/get',
      getdynamicFields: 'api/' + apiVersion + '/connectorbase/init',
      getAllConnectorBase: 'api/' + apiVersion + '/connectorbase/all',
      },
    provisioner: {
      postProvisioner: 'api/' + apiVersion + '/cloud/provisioner/operation',
      getAllProvisioner: 'api/' + apiVersion + '/cloud/provisioner/list',
      getprovisionerByService: 'api/' + apiVersion + '/cloud/provisioner/list/by/service/',
      getServiceByProvisionerType: 'api/' + apiVersion + '/cloud/provisioner/service/by/provisioner-type/',
      getProvisionerTypes: 'api/' + apiVersion + '/cloud/provisioner/list/provisioner-types',
      getProvisionerById: 'api/' + apiVersion + '/cloud/provisioner/get/',
      removeProvisioner: 'api/' + apiVersion + '/cloud/provisioner/operation/',
      updateProvisioner: 'api/' + apiVersion + '/cloud/provisioner/operation/',
    },
    storageConfig: {
      postStorageConfig: 'api/' + apiVersion + '/cloud/storage',
      getAllStorageConfig: 'api/' + apiVersion + '/cloud/storage/list',
      getAllStorageConfigbyId: 'api/' + apiVersion + '/cloud/storage/get/',
      deleteStorageConfigbyId: 'api/' + apiVersion + '/cloud/storage/',
      updateStorageConfig: 'api/' + apiVersion + '/cloud/storage/',
    },
    modelSpace: {
      createModelSpace: 'api/' + apiVersion + '/modelspace/create',
      getRunTime: 'api/' + apiVersion + '/modelspace/runtime/container/images',
      deleteMS: 'api/' + apiVersion + '/modelspace',
      stopMS: 'api/' + apiVersion + '/modelspace/stop/',
      getRecents: 'api/' + apiVersion + '/modelspace/notebooks/recent',
      deleteRecents: 'api/' + apiVersion + '/modelspace/notebooks/recent/',
      createRecents: 'api/' + apiVersion + '/modelspace/notebooks/create',
      getConnectionDetails: 'api/' + apiVersion + '/modelspace/connect',
      createStroageFileID: 'api/' + apiVersion + '/cloud/storage/file/get',
      getStroageFileByID: 'api/' + apiVersion + '/cloud/storage/file/get',
      getModelspaceDetails: 'api/' + apiVersion + '/modelspace/',
      getConnectedList: 'api/' + apiVersion + '/modelspace/storage-file/',
    },
    additionalMount: {
      createMount: 'api/' + apiVersion + '/cloud/storage/file/mount/create',
      getMountByFileId: 'api/' + apiVersion + '/cloud/storage/file/mount/list/',
      unMountStorage: 'api/' + apiVersion + '/cloud/mount/'
    },
    scheduler: {
      GetSchedulerTypes: 'api/' + apiVersion + '/scheduler/types',
      GetSchedulerFor: 'api/' + apiVersion + '/scheduler/for/',
      GetSchedulerByTypes: 'api/' + apiVersion + '/scheduler/all',
      GetSchedulerbyId: 'api/' + apiVersion + '/scheduler/',
      UpdateScheduler: 'api/' + apiVersion + '/scheduler/',
      GetAllScheduler: 'api/' + apiVersion + '/scheduler/all',
      cancelScheduler: 'api/' + apiVersion + '/scheduler/stop/'
    },
    superAdmin: {
      postTenant: 'api/admin/' + apiVersion + '/organisation',
      getAllTenant: 'api/admin/' + apiVersion + '/organisation/all',
      getSingleTenant: 'api/admin/' + apiVersion + '/organisation/',
      removeSingleTenant: 'api/admin/' + apiVersion + '/organisation/',
      updateTenant: 'api/admin/' + apiVersion + '/organisation/',
      activeTenant: 'api/admin/' + apiVersion + '/activate/',
      deactiveTenant: 'api/admin/' + apiVersion + '/deactivate/',
      getTenantType: 'api/admin/' + apiVersion + '/organisation/list/by/tenant/type',

    },
    platformprovisioner: {
      postplatformProvisioner: 'api/' + apiVersion + '/platform/default/cloud/provisioner',
      getAllplatformProvisioner: 'api/' + apiVersion + '/platform/default/cloud/provisioner',
      updateplatformProvisioner: 'api/' + apiVersion + '/platform/default/cloud/provisioner',
      removeplatformProvisioner: 'api/' + apiVersion + '/platform/default/cloud/provisioner',
    },
    instancetype: {
      getAllInstanceType: 'api/' + apiVersion + '/cloud/instancetype/alias/list/',
      postInstanceType: 'api/' + apiVersion + '/cloud/instancetype/alias',
      getInstanceTypeById: 'api/' + apiVersion + '/cloud/instancetype/alias/list/get/',
      deleteInstanceType: 'api/' + apiVersion + '/cloud/instancetype/alias/',
      updateInstanceType: 'api/' + apiVersion + '/cloud/instancetype/alias/',
      getCloudType: 'api/' + apiVersion + '/cloud/instancetype/alias/list/cloud/',
      getInstanceType: 'api/' + apiVersion + '/cloud/instancetype/alias/list/by/instance/type/',
      getRegionName: 'api/' + apiVersion + '/cloud/instancetype/alias/list/by/region/',
      listCloudType: 'api/' + apiVersion + '/cloud/instancetype/alias/list/cloud',
      getRegionAndInstanceType: 'api/' + apiVersion + '/cloud/instancetype/alias/list/instance/type/by/region/'
    },
    cloudImages: {
      getAllCloudImages: 'api/' + apiVersion + '/cloud/machine/images/list',
      postCloudImage: 'api/platform/' + apiVersion + '/cloud/images',
      getCloudImagesById: 'api/' + apiVersion + '/cloud/machine/images/get',
      deleteCloudImage: 'api/platform/' + apiVersion + '/cloud/images/',
      updateCloudImage: 'api/platform/' + apiVersion + '/cloud/images/',
      getCloudType: 'api/' + apiVersion + '/cloud/instancetype/alias/list/cloud/',
      getImageType: 'api/' + apiVersion + '/cloud/machine/images/list/by/image/type',
      getimageRegionName: 'api/' + apiVersion + '/cloud/machine/images/list/by/region/',
      getArchitecture: 'api/' + apiVersion + '/cloud/machine/images/list/by/architecture',
      getimageZoneName: 'api/' + apiVersion + '/cloud/machine/images/list/by/zone/'
    },
    virtualmachine: {
      getAllVMType: 'api/' + apiVersion + '/cloud/virtualmachine/type/list',
      getVMTypeList: 'api/' + apiVersion + '/cloud/virtualmachine/type/list/all',
      postVMType: 'api/' + apiVersion + '/cloud/virtualmachine/type/operation/',
      updateVMType: 'api/' + apiVersion + '/cloud/virtualmachine/type/operation/',
      deleteVMType: 'api/' + apiVersion + '/cloud/virtualmachine/type/operation/',
      getVMProvisioners: 'api/' + apiVersion + '/cloud/virtualmachine/type/operation/provisioner/',
      updateVMTypeStatus: 'api/' + apiVersion + '/cloud/virtualmachine/type/operation/service/',
    },
    imagemapping: {
      getAllCloudImages: 'api/' + apiVersion + '/cloud/machine/images/list',
      postCloudImage: 'api/platform/' + apiVersion + '/cloud/images',
      getCloudImagesById: 'api/' + apiVersion + '/cloud/machine/images/get/',
      deleteCloudImage: 'api/platform/' + apiVersion + '/cloud/images/',
      updateCloudImage: 'api/platform/' + apiVersion + '/cloud/images/',
      getCloudType: 'api/' + apiVersion + '/cloud/machine/images/list/by/cloud/',
      getImageType: 'api/' + apiVersion + '/cloud/machine/images/list/by/image/type',
      getimageRegionName: 'api/' + apiVersion + '/cloud/machine/images/list/by/region/',
      getArchitecture: 'api/' + apiVersion + '/cloud/machine/images/list/by/architecture',
      listCloudType: 'api/' + apiVersion + '/cloud/machine/images/list/by/cloud',
    },
    dashboard: {
      get_sample: 'employees'
    },
    setting: {
      getMenuList: 'api/' + apiVersion + '/settings/menu/get',
      updateMenu: 'api/' + apiVersion + '/settings/menu/reorder',
      getMenuOption: 'api/' + apiVersion + '/settings/menu/types',
      getProps: 'api/' + apiVersion + '/settings/menu/property/by/',
    },
    widgets: {
      saveCustomMenu: 'api/' + apiVersion + '/menu/dashboard/save',
      getMenuDashboard: 'api/' + apiVersion + '/menu/dashboard/by',
      addWidget: 'api/' + apiVersion + '/menu/widget/save',
      getDashboardInfo : 'api/' + apiVersion + '/menu/dashboard',
      updateWidgetById : 'api/' + apiVersion + '/menu/widget/update',
      removeWidgetById : 'api/' + apiVersion + '/menu/widget/remove',
      removeDashboardByName : 'api/' + apiVersion + '/menu/dashboard/remove',
      getMenuById: 'api/' + apiVersion + '/menu/dashboard/all',
      updateMenuName : 'api/' + apiVersion + '/menu/dashboard',
    },
    widget: {
      getWidgetData: 'api/' + apiVersion + '/widget/menu/get'
    },
  },
  fileapi: {
    fileJobs: {
      extractFile: 'api/' + apiVersion + '/middleware/storage/zip',
      copyFile: 'api/' + apiVersion + '/middleware/storage/copy',
      moveFile: 'api/' + apiVersion + '/middleware/storage/move',
      trashFolder: 'api/' + apiVersion + '/middleware/storage/trash',
      deleteFolder: 'api/' + apiVersion + '/middleware/storage/delete',
      restoreFile: 'api/' + apiVersion + '/middleware/storage/restore',
      renameFile: 'api/' + apiVersion + '/middleware/storage/rename',
      SaveFileVersion: 'api/' + apiVersion + '/middleware/storage/version/versioning',
      restoreVersionObjects:'api/' + apiVersion + '/middleware/storage/version/restore',
      getPendingJobs: 'api/' + apiVersion + '/middleware/storage/pending-jobs',
      ViewOriginalVersion: 'api/' + apiVersion + '/middleware/storage/version/original',
      GetStorageJobId:'api/' + apiVersion + '/middleware/storage/job/'
    }
  },
  storageApi: {
    base: { url: STORAGE_BASE_URL },
    prefixs: {
      createPrefix: '/api/v1/buckets/prefix',
      deletePrefix: '/api/v1/buckets/prefix'
    },
    objects: {
      listObjects: '/api/v1/buckets/objects',
      downloadObject: '/api/v1/buckets/object',
      uploadObject: '/api/v1/buckets/object',
      uploadAnnotationObject: '/api/v1/buckets/object/annotation',
      deleteObject: '/api/v1/buckets/object',
      copyObject: '/api/v1/buckets/object/copy',
      trashObject: '/api/v1/buckets/objects/trash',
      getBuckets: '/api/v1/buckets',
      getObjectVersions: '/api/v1/buckets/objects/version',
      downloadVersion: '/api/v1/buckets/object/version',
      listVersionObjects: '/api/v1/buckets/objects/version',
      ViewVersionObjects:'/api/v1/buckets/object/version'
    }
  },
  drsApi: {
    base: { url: DRS_BASE_URL },
    objects: {
      renderObject: '/api/v1/rendering',
    }
  }
}
